var React = require('react');

function DesktopWhitebgtop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M960.503 3376C1882.54 3376 2630 2620.26 2630 1688C2630 755.743 1882.54 0 960.503 0C38.4633 0 -709 755.743 -709 1688C-709 2620.26 38.4633 3376 960.503 3376Z","fill":"url(#paint0_linear_5686_1994)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear_5686_1994","x1":"960.5","y1":"0","x2":"960.5","y2":"3376","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"white","key":0}),React.createElement("stop",{"offset":"0.078125","stopColor":"#F7F6F3","key":1}),React.createElement("stop",{"offset":"0.911458","stopColor":"#F7F6F3","key":2}),React.createElement("stop",{"offset":"0.989583","stopColor":"white","key":3})]))]);
}

DesktopWhitebgtop.defaultProps = {"width":"1920","height":"458","viewBox":"0 0 1920 458","fill":"none"};

module.exports = DesktopWhitebgtop;

DesktopWhitebgtop.default = DesktopWhitebgtop;
